import { sharedBridge, sharedCalculation, sharedContexts, sharedEvidence, sharedIntelligence, sharedReconciliation, sharedResponsibility, sharedSubmission } from '../shared';
import type { TrackB1Model, TrackB1Ports } from './types';

export const trackB1Fixture: TrackB1Model = {
  context: sharedContexts.find((context) => context.track === 'B1')!,
  deadlines: [],
  evidence: sharedEvidence.slice(0, 1),
  reconciliation: sharedReconciliation,
  calculation: { ...sharedCalculation, rulePackage: 'Business VAT monthly candidate · 2026.01' },
  responsibilities: sharedResponsibility.map((step) => step.action === 'prepare' ? { ...step, actorLabel: 'Business owner · preparer' } : step),
  submission: sharedSubmission,
  bridge: sharedBridge,
  freezeCases: [
    { id: 'freeze-1', buyerName: 'Enterprise Buyer Plc', buyerReference: 'PO-38144', amountLabel: '₦1,825,000.00', urgencyLabel: 'Payment held for 4 days', state: 'ready-for-review' },
  ],
  invoices: [
    { id: 'b1-inv-1', buyerName: 'Enterprise Buyer Plc', amountLabel: '₦1,825,000.00', invoiceNumber: 'ADB-2026-0082', state: 'needs-review', issue: 'Confirm buyer identifier and supply details.' },
  ],
  intelligence: sharedIntelligence,
};

export const noopTrackB1Ports: TrackB1Ports = { openFreezeCase: () => undefined, createInvoice: () => undefined, reviewInvoice: () => undefined };
